// 모델 헬퍼

// =================================================================================================
// 가져오기
// =================================================================================================
// 고정 영역

// 동적 영역

// =================================================================================================
// 상수
// =================================================================================================
// 스토어 경로
const storePath = {
  user: {
    pet: {
      petName: 'user.pet.petName',
    },
  },
};

// =================================================================================================
// 내보내기
// =================================================================================================
export default {
  storePath,
};
